$(function() {

    function setHeaderHeight(size = $(".main-header").height()) {

        if ($(".main-header").attr('data-size') === "") {
            $(".main-header").attr('data-size', size);
        }

        $(".main-header").css("height", size + "px");

    }
    // if ($(window).width() > 768) {
    setHeaderHeight()
    // }
    $(window).scroll(function() {
        var sticky = $('.main-header'),
            scroll = $(window).scrollTop();
        // if ($(window).width() > 768) {
        if (scroll >= 400) {
            sticky.addClass('fixed-header')
        } else {
            sticky.removeClass('fixed-header');
        }
        // }
    });

    // Reviews slider
            if ($('.reviews').length) {
                $(".reviews .owl-carousel").owlCarousel({
                    loop: true,
                    margin: 0,
                    nav: false,
                    autoplay: true,
                    responsive: {
                        0: {
                            items: 1
                        }
                    }
                });
            }

});